<template>
  <div>
    <div class="pdfPopupNavbar">
      <img src="@/images/modal-close.svg" class="nav-link-icon filter-primary" @click="hidePdfGenerator"/>
      <div
        v-if="!generatingPdf"
        class="w-button pointer"
        @click="generate"
      >
        GENEROVAŤ
      </div>
      <v-progress-circular
        v-else
        class="loading-spinner small"
        indeterminate
      ></v-progress-circular>
    </div>
    <div class="body" id="clientFinancingNeeds">
      <div class="header">
        <div class="logo"></div>
        <div class="subeheading">jednoznačne najrýchlejšia a najvýhodnejšia hypotéka, <span class="ucel">{{ purposeLabel }} </span>
          <span class="bold">p. {{ $store.getters["mortgageDetailState/getApplicant"].last_name }}</span></div>
      </div>

      <div class="results-legend zok">
        <div class="break-40px"></div>
        <p>celkom</p>
        <p>sadzba</p>
        <p>splátka</p>
        <p>poplatok</p>
        <p>splatnosť</p>
        <p>vedenie účtu</p>
        <p>fixácia</p>
      </div>
      <div
        class="mortgage-result-broker zok"
        :style="{'mb-1': offer.length > 1}"
        v-for="(offer, index) in banksOffers"
        :key="index"
        v-if="offer.success"
      >
        <div
          class="mortgage-parameters zok"
        >
          <img :src="getBankImage(offer.extra.bank_code_name)" loading="lazy" class="bank-logo big"
               alt="">
          <div class="bold wrap100px green">
            {{ offer.pozicana_suma | dotTheAmount }} €
          </div>
          <div class="bold wrap50px">{{ offer.sadzba }}<span
            class="upper-index">%</span></div>
          <div  class="bold wrap100px green">
            {{ offer.mesacna_splatka | dotTheAmount }} €
          </div>
          <div  class="bold wrap50px">
            {{ offer.popl_sprac_hypo | dotTheAmount }} €
          </div>
          <div class="bold">{{ offer.splatnost_r }} <span
            class="upper-index">ROKOV</span></div>
          <div  class="bold wrap100px">
            {{ offer.popl_za_vedenie_uctu }} €<span class="upper-index">/ mesiac</span>
          </div>
          <div  class="bold wrap50px">{{ offer.fix }}</div>
        </div>
        <div class="discount-list"></div>
      </div>
      <div class="pagebreak"> </div>
      <div class="welcome-block">
        <img class="agentimage" :src="broker.profile_image ? broker.profile_image : 'https://uploads-ssl.webflow.com/641c1368683a584b0eb1d8a2/641dbf1cfcf9726751be633a_agent%20image.png'"/>
        <div class="message">
          <div>Volám sa <span class="bold">{{ broker.first_name }} {{ broker.last_name }}</span> a budem Váš osobný bankár. Ďalší postup je popísaný
            nižšie a na email som si dovolil Vám poslať pozvánku do našej aplikácie.
          </div>
        </div>
        <div class="image"></div>
      </div>
      <div class="step-block">
        <div class="text-block">
          <div class="bold big"><span class="green">Vyberte si</span> najvýhodnejšie financovanie</div>
          <div>nastavte si fixáciu alebo splatnosť podľa predstavy a sledujte ako sa ponuka prepočíta.</div>
        </div>
        <div class="step-number">
          <div>1</div>
        </div>
        <div class="mockupimg step-1"></div>
      </div>
      <div class="step-block">
        <div class="text-block">
          <div class="bold big"><span class="green">Dohodnite si </span>podpis vygenerovaných žiadostí</div>
          <div>na vygenerovanie žiadostí však potrebujeme aby ste nám doplnili pár informácii o sebe, vašom príjme a
            výdavkoch
          </div>
        </div>
        <div class="step-number">
          <div>2</div>
        </div>
        <div class="mockupimg _2step"></div>
      </div>
      <div class="step-block">
        <div class="text-block">
          <div class="bold big">Na záver <span class="green">nahrajte podklady pre banku</span></div>
          <div>posledným krokom je nahranie podkladov na schvaľovanie do cloudu, ktorý automaticky identifikuje potrebné
            doklady a vyzve Vás na ich nahratie.
          </div>
        </div>
        <div class="step-number">
          <div>3</div>
        </div>
        <div class="mockupimg _3step"></div>
      </div>
      <div class="pagebreak"> </div>
      <div class="step-block">
        <div class="text-block">
          <div class="bold big"><span class="green">Hotovo</span>. O zvyšok sa postaráme</div>
          <div>o priebehu schvaľovania ste informovaný emailovými a push notifikáciami, aby ste vždy vedeli v akej fáze
            procesu sa nachádzame.
          </div>
        </div>
        <div class="step-number">
          <div>4</div>
        </div>
        <div class="mockupimg _4step"></div>
      </div>
      <div class="welcome-block oposit">
        <img class="agentimage oposit" :src="broker.profile_image ? broker.profile_image : 'https://uploads-ssl.webflow.com/641c1368683a584b0eb1d8a2/641dbf1cfcf9726751be633a_agent%20image.png'"/>
        <div class="message">
          <div>Možno sa pýtate prečo by ste mali využiť služby bankari.sk. Pripravil som pre Vás krátky zoznam benefitov.
            Keď budete mať otázky neváhajte sa so mnou spojiť.<br></div>
        </div>
      </div>
      <div class="benefit-block">
        <div class="w-layout-grid grid-3-columns gap-32px">
          <a class="card link-card feature-item-colored w-inline-block">
            <div class="mg-bottom-32px greenbenefits">
              <div class="inner-container">
                <div class="image-wrapper alignright">
                  <div class="image-2"></div>
                </div>
              </div>
            </div>
            <div class="card-feature-item-content"><h3 class="color-neutral-100">o
              40%&nbsp;rýchlejšie</h3>
              <p>vďaka automatizácii spracujeme hypotéku o 40% rýchlejšie ako štandardný hypotekárny poradca</p></div>
          </a><a href="#" class="card link-card feature-item-colored w-inline-block">
          <div class="mg-bottom-32px greenbenefits">
            <div class="inner-container">
              <div class="image-wrapper alignright">
                <div class="image-2 uspesnost"></div>
              </div>
            </div>
          </div>
          <div class="card-feature-item-content"><h3 class="color-neutral-100">100% úspešnosť</h3>
            <p>hypotéku na mieru vypočíta na základe parametrov všetkých bánk náš sofistikovaný algoritmus na počkanie</p>
          </div>
        </a><a href="#" class="card link-card feature-item-colored w-inline-block">
          <div class="mg-bottom-32px greenbenefits">
            <div class="inner-container">
              <div class="image-wrapper alignright">
                <div class="image-2 posudok"></div>
              </div>
            </div>
          </div>
          <div class="card-feature-item-content"><h3 class="color-neutral-100">právna pomoc</h3>
            <p>náš advokát Vám skontroluje rezervačnú a kúpnu zmluvu, ktorú Vám zašlú v prípade kúpy nehnuteľnosti</p></div>
        </a></div>
      </div>
    </div>
  </div>
</template>

<script>
import imagesConvert from "../../../../../mixins/imagesConvert";
import mortgageUtils from "../../../../../mixins/mortgageUtils";
import ConvertApi from "convertapi-js";
import {getFile} from "@/services/brokerService";


export default {
  name: "ClientFinancingOfferGenerator",
  props: {
    mortgage: Object,
    banksOffers: Array,
  },
  mixins: [
    imagesConvert,
    mortgageUtils
  ],
  created() {
    this.broker = this.$store.getters["userState/getMe"];
    const purpose = this.getMortgagePurpose();
    switch (purpose) {
      case "nadobudnutie":
        this.purposeLabel = "na kúpu nehnuteľnosti";
        return;
      case "refinancovanie":
        this.purposeLabel = " pre refinancovanie Vásho úveru";
        return;
      case "bezucel":
        this.purposeLabel = "pre americkú hypotéku";
        return;
    }
  },
  methods: {
    hidePdfGenerator() {
      this.$store.commit("popupManagerState/toggleClientFinancingOffer", false);
    },
    async generate() {
      this.generatingPdf = true;
      const clientsFinancingOffers = document.getElementById("clientFinancingNeeds");
      const htmlString =
        `<html>
          <head>
            <meta charset="UTF-8">
            <meta name="viewport" content="width=device-width, user-scalable=no, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0">
            <meta http-equiv="X-UA-Compatible" content="ie=edge">
            <title>Document</title>
            <style>
              @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;500;800;900&display=swap');

              html {
                  font-family: sans-serif;
                  -ms-text-size-adjust: 100%;
                  -webkit-text-size-adjust: 100%
              }

              @media print{
                margin: 0px;
              }

              .pagebreak {
                  clear: both;
                  page-break-after: always;
              }

              body{
                font-family: Poppins, sans-serif !important;
                font-size: 20pt;
                color: #0A1953;
              }

              article,aside,details,figcaption,figure,footer,header,hgroup,main,menu,nav,section,summary {
                  display: block
              }

              a {
                  background-color: transparent
              }

              a:active,a:hover {
                  outline: 0
              }

              abbr[title] {
                  border-bottom: 1px dotted
              }

              b,strong {
                  font-weight: bold
              }

              dfn {
                  font-style: italic
              }

              h1 {
                  font-size: 22pt;
                  margin: .67em 0
              }

              mark {
                  background: #ff0;
                  color: #000
              }

              small {
                  font-size: 80%
              }

              sub,sup {
                  font-size: 75%;
                  line-height: 0;
                  position: relative;
                  vertical-align: baseline
              }

              sup {
                  top: -0.5em
              }

              sub {
                  bottom: -0.25em
              }

              img {
                  border: 0
              }

              svg:not(:root) {
                  overflow: hidden
              }

              figure {
                  margin: 1em 40px
              }

              hr {
                  box-sizing: content-box;
                  height: 0
              }

              pre {
                  overflow: auto
              }

              .results-legend {
                display: -ms-grid;
                display: grid;
                min-width: 950px;
                margin-top: 20px;
                margin-bottom: 20px;
                padding-right: 20px;
                padding-left: 20px;
                -webkit-box-pack: center;
                -webkit-justify-content: center;
                -ms-flex-pack: center;
                justify-content: center;
                justify-items: center;
                -webkit-box-align: center;
                -webkit-align-items: center;
                -ms-flex-align: center;
                align-items: center;
                grid-auto-columns: 1fr;
                grid-column-gap: 16px;
                grid-row-gap: 16px;
                -ms-grid-columns: 0.5fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 0.5fr;
                grid-template-columns: 0.5fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 0.5fr;
                -ms-grid-rows: auto;
                grid-template-rows: auto;
              }

              .results-legend.zok {
                -ms-grid-columns: 0.5fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
                grid-template-columns: 0.5fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
                text-align: center;
              }

              .mortgage-parameters {
                display: -ms-grid;
                display: grid;
                min-width: 0px;
                margin-bottom: 0px;
                padding: 0px;
                -webkit-box-pack: center;
                -webkit-justify-content: center;
                -ms-flex-pack: center;
                justify-content: center;
                justify-items: center;
                -webkit-box-align: center;
                -webkit-align-items: center;
                -ms-flex-align: center;
                align-items: center;
                grid-auto-columns: 1fr;
                grid-column-gap: 16px;
                grid-row-gap: 16px;
                -ms-grid-columns: 0.5fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 0.5fr;
                grid-template-columns: 0.5fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 0.5fr;
                -ms-grid-rows: auto;
                grid-template-rows: auto;
                border-radius: 10px;
                background-color: transparent;
              }

              .mortgage-parameters.zok {
                -ms-grid-columns: 0.5fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
                grid-template-columns: 0.5fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
              }

              .mortgage-result-broker {
                display: -webkit-box;
                display: -webkit-flex;
                display: -ms-flexbox;
                display: flex;
                min-width: 950px;
                margin-bottom: 20px;
                margin-right: 20px;
                margin-left: 20px;
                padding: 30px 20px;
                -webkit-box-orient: vertical;
                -webkit-box-direction: normal;
                -webkit-flex-direction: column;
                -ms-flex-direction: column;
                flex-direction: column;
                -webkit-box-align: stretch;
                -webkit-align-items: stretch;
                -ms-flex-align: stretch;
                align-items: stretch;
                border-radius: 10px;
                background-color: #f8f9fa;
              }


              code,kbd,pre,samp {
                  font-family: monospace, monospace;
                  font-size: 1em
              }

              button,input,optgroup,select,textarea {
                  color: inherit;
                  font: inherit;
                  margin: 0
              }

              button {
                  overflow: visible
              }

              button,select {
                  text-transform: none
              }

              button,html input[type="button"],input[type="reset"] {
                  -webkit-appearance: button;
                  cursor: pointer
              }

              button[disabled],html input[disabled] {
                  cursor: default
              }

              button::-moz-focus-inner,input::-moz-focus-inner {
                  border: 0;
                  padding: 0
              }

              input {
                  line-height: normal
              }

              input[type='checkbox'],input[type='radio'] {
                  box-sizing: border-box;
                  padding: 0
              }

              input[type='number']::-webkit-inner-spin-button,input[type='number']::-webkit-outer-spin-button {
                  height: auto
              }

              input[type='search'] {
                  -webkit-appearance: none
              }

              input[type='search']::-webkit-search-cancel-button,input[type='search']::-webkit-search-decoration {
                  -webkit-appearance: none
              }

              fieldset {
                  border: 1px solid #c0c0c0;
                  margin: 0 2px;
                  padding: .35em .625em .75em
              }

              legend {
                  border: 0;
                  padding: 0
              }

              textarea {
                  overflow: auto
              }

              optgroup {
                  font-weight: bold
              }

              table {
                  border-collapse: collapse;
                  border-spacing: 0
              }

              td,th {
                  padding: 0
              }

              /* ==========================================================================
                Start of base Webflow CSS - If you're looking for some ultra-clean CSS, skip the boilerplate and see the unminified code below.
                ========================================================================== */
              @font-face {
                  font-family: 'webflow-icons';
                  src: url("data:application/x-font-ttf;charset=utf-8;base64,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") format('truetype');
                  font-weight: normal;
                  font-style: normal
              }

              [class^="w-icon-"],[class*=" w-icon-"] {
                  font-family: 'webflow-icons' !important;
                  speak: none;
                  font-style: normal;
                  font-weight: normal;
                  font-variant: normal;
                  text-transform: none;
                  line-height: 1;
                  -webkit-font-smoothing: antialiased;
                  -moz-osx-font-smoothing: grayscale
              }

              .w-icon-slider-right:before {
                  content: "\e600"
              }

              .w-icon-slider-left:before {
                  content: "\e601"
              }

              .w-icon-nav-menu:before {
                  content: "\e602"
              }

              .w-icon-arrow-down:before,.w-icon-dropdown-toggle:before {
                  content: "\e603"
              }

              .w-icon-file-upload-remove:before {
                  content: "\e900"
              }

              .w-icon-file-upload-icon:before {
                  content: "\e903"
              }

              * {
                  -webkit-box-sizing: border-box;
                  -moz-box-sizing: border-box;
                  box-sizing: border-box
              }

              html {
                  height: 100%
              }

              img {
                  max-width: 100%;
                  vertical-align: middle;
                  display: inline-block
              }

              html.w-mod-touch * {
                  background-attachment: scroll !important
              }

              .w-block {
                  display: block
              }

              .w-inline-block {
                  max-width: 100%;
                  display: inline-block
              }

              h1,h2,h3,h4,h5,h6 {
                  font-weight: bold;
                  margin-bottom: 10px
              }

              h1 {
                  font-size: 38px;
                  line-height: 44px;
                  margin-top: 20px
              }

              h2 {
                  font-size: 32px;
                  line-height: 36px;
                  margin-top: 20px
              }

              h3 {
                  font-size: 24px;
                  line-height: 30px;
                  margin-top: 20px
              }

              h4 {
                  font-size: 18px;
                  line-height: 24px;
                  margin-top: 10px
              }

              h5 {
                  font-size: 14px;
                  line-height: 20px;
                  margin-top: 10px
              }

              h6 {
                  font-size: 12px;
                  line-height: 18px;
                  margin-top: 10px
              }

              p {
                  margin-top: 0;
                  margin-bottom: 10px
              }

              .w-container {
                  margin-left: auto;
                  margin-right: auto;
                  max-width: 940px
              }

              .w-container:before,.w-container:after {
                  content: " ";
                  display: table;
                  grid-column-start: 1;
                  grid-row-start: 1;
                  grid-column-end: 2;
                  grid-row-end: 2
              }

              .w-container:after {
                  clear: both
              }

              .w-container .w-row {
                  margin-left: -10px;
                  margin-right: -10px
              }

              .w-row:before,.w-row:after {
                  content: " ";
                  display: table;
                  grid-column-start: 1;
                  grid-row-start: 1;
                  grid-column-end: 2;
                  grid-row-end: 2
              }

              .w-row:after {
                  clear: both
              }

              .w-row .w-row {
                  margin-left: 0;
                  margin-right: 0
              }

              .w-col {
                  position: relative;
                  float: left;
                  width: 100%;
                  min-height: 1px;
                  padding-left: 10px;
                  padding-right: 10px
              }

              /* ==========================================================================
                Start of custom Webflow CSS
                ========================================================================== */
              .w-layout-grid {
                  display: -ms-grid;
                  display: grid;
                  grid-auto-columns: 1fr;
                  -ms-grid-columns: 1fr 1fr;
                  grid-template-columns: 1fr 1fr;
                  -ms-grid-rows: auto auto;
                  grid-template-rows: auto auto;
                  grid-row-gap: 16px;
                  grid-column-gap: 16px;
              }

              .upper-index {
                position: relative;
                top: auto;
                bottom: 0.8em;
                margin-left: 2px;
                font-size: 10pt;
                line-height: 10px;
              }

              .header {
                  display: flex;
                  height: 600px;
                  margin-right: -40px;
                  margin-left: -40px;
                  flex-direction: column;
                  justify-content: center;
                  align-items: center;
                  background-image: url("https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f34_Header%20background-min.png");
                  background-position: 50% 50%;
                  background-size: cover;
                  background-repeat: no-repeat;
              }

              .bank-logo.big {
                position: static;
                width: 70px;
                height: auto;
              }

              .body {
                  padding-right: 40px;
                  padding-bottom: 40px;
                  padding-left: 40px;
                  background-color: #f8f9fa;
                  font-family: Poppins, sans-serif;
                  color: #0a1953;
                  font-size: 18px;
                  line-height: 23px;
                  font-weight: 500;
              }

              .subeheading {
                  max-width: 50%;
                  margin-top: 20px;
                  text-align: center;
              }

              .bold {
                  font-weight: 700;
              }

              .bold.big {
                  margin-bottom: 10px;
                  font-size: 32pt;
                  line-height: 36pt;
              }

              .list-of-offers {
                  margin-top: -40px;
                  margin-bottom: 100px;
              }

              .welcome-block {
                  position: relative;
                  display: flex;
                  overflow: visible;
                  max-height: 200px;
                  margin-top: 200px;
                  margin-bottom: 100px;
                  flex-direction: row;
                  justify-content: space-between;
                  align-items: flex-end;
                  border-radius: 10px;
                  background-color: #edf5f7;
              }

              .welcome-block.oposit {
                  margin-top: 120px;
                  flex-direction: row-reverse;
              }

              .agentimage {
                  width: 300px;
                  height: 300px;
                  border-bottom-left-radius: 10px;
                  background-position: 50% 50%;
                  background-size: cover;
                  background-repeat: no-repeat;
              }

              .agentimage.oposit {
                  border-bottom-left-radius: 0px;
                  border-bottom-right-radius: 10px;
                  background-position: 100% 50%;
                  background-size: contain;
              }

              .message {
                  position: absolute;
                  left: 200px;
                  top: -30px;
                  width: 50%;
                  padding: 20px;
                  border-radius: 10px;
                  background-color: #fff;
                  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.1);
              }

              .image {
                  width: 200px;
                  height: 200px;
                  margin-right: -5px;
                  margin-bottom: -20px;
                  background-image: url("https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f30_invitation%20image.png");
                  background-position: 50% 50%;
                  background-size: contain;
                  background-repeat: no-repeat;
              }

              .step-block {
                  position: relative;
                  display: -ms-grid;
                  display: grid;
                  margin-bottom: 40px;
                  padding: 40px 80px 0px;
                  justify-content: space-between;
                  align-items: center;
                  grid-auto-columns: 1fr;
                  grid-column-gap: 16px;
                  grid-row-gap: 16px;
                  -ms-grid-columns: 1fr 1fr;
                  grid-template-columns: 1fr 1fr;
                  -ms-grid-rows: auto;
                  grid-template-rows: auto;
                  border-radius: 10px;
                  background-color: #edf5f7;
              }

              .text-block {
                  margin-right: 20px;
                  margin-bottom: 60px;
              }

              .green {
                  color: #258b66;
              }

              .step-number {
                  position: absolute;
                  left: 0%;
                  top: auto;
                  right: auto;
                  bottom: 0%;
                  display: flex;
                  width: 100px;
                  height: 100px;
                  padding-top: 20px;
                  padding-right: 20px;
                  justify-content: center;
                  align-items: center;
                  border-bottom-left-radius: 10px;
                  background-image: url("https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f33_step%20background.png");
                  background-position: 50% 50%;
                  background-size: contain;
                  background-repeat: no-repeat;
                  color: #fff;
                  font-size: 42px;
                  line-height: 42px;
                  font-weight: 700;
              }

              .logo {
                  width: 400px;
                  height: 80px;
                  background-image: url("https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f2e_logo%20ponuka%20financovania.svg");
                  background-position: 50% 50%;
                  background-size: contain;
                  background-repeat: no-repeat;
              }

              .mockupimg {
                  width: 100%;
                  height: 400px;
              }

              .mockupimg._2step {
                  background-image: url("https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f35_step%202%20image.png");
                  background-position: 50% 100%;
                  background-size: contain;
                  background-repeat: no-repeat;
              }

              .mockupimg._3step {
                  background-image: url("https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f2f_step%203%20image.png");
                  background-position: 50% 100%;
                  background-size: contain;
                  background-repeat: no-repeat;
              }

              .mockupimg._4step {
                  background-image: url("https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f31_step%204%20image.png");
                  background-position: 50% 100%;
                  background-size: contain;
                  background-repeat: no-repeat;
              }

              .mockupimg.step-1 {
                  background-image: url("https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f36_step%201%20image.png");
                  background-position: 50% 100%;
                  background-size: contain;
                  background-repeat: no-repeat;
              }

              .card-feature-item-content {
                  display: flex;
                  flex-direction: column;
                  flex: 1;
              }

              .heading-h3-size {
                  color: #0a1953;
                  font-size: 24px;
                  line-height: 1.417em;
                  font-weight: 700;
              }

              .color-neutral-100 {
                  font-size: 28pt;
                  color: #fff;
              }

              .grid-3-columns {
                  display: -ms-grid;
                  display: grid;
                  align-items: start;
                  grid-auto-columns: 1fr;
                  grid-column-gap: 28px;
                  grid-row-gap: 28px;
                  -ms-grid-columns: 1fr 1fr 1fr;
                  grid-template-columns: 1fr 1fr 1fr;
                  -ms-grid-rows: auto;
                  grid-template-rows: auto;
              }

              .grid-3-columns.gap-32px {
                  align-items: stretch;
                  grid-column-gap: 32px;
                  grid-row-gap: 32px;
              }

              .image-wrapper {
                  display: flex;
                  overflow: hidden;
                  flex-direction: column;
                  justify-content: center;
                  transform: translate(0px, 0px);
              }

              .image-wrapper.alignright {
                  align-items: flex-end;
              }

              .image-2 {
                  width: 200px;
                  height: 150px;
                  background-image: url("https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912e7c_o%2040%25%20r%C3%BDchlej%C5%A1ie.png");
                  background-position: 50% 50%;
                  background-size: contain;
                  background-repeat: no-repeat;
              }

              .image-2.uspesnost {
                  background-image: url("https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912e7b_100%25%20%C3%BAspe%C5%A1nos%C5%A5.png");
              }

              .image-2.posudok {
                  background-image: url("https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912e7a_s%20nami%20%C5%A1etr%C3%ADte.png");
              }

              .mg-bottom-32px {
                  margin-bottom: 32px;
              }

              .mg-bottom-32px.greenbenefits {
                  display: flex;
                  margin-top: -60px;
                  margin-bottom: 0px;
                  justify-content: flex-end;
              }

              .card {
                  overflow: hidden;
                  border-style: solid;
                  border-width: 1px;
                  border-color: #eef5f7;
                  border-radius: 24px;
                  background-color: #fff;
                  box-shadow: 0 2px 7px 0 rgba(20, 20, 43, 0.02);
              }

              .card.link-card {
                  display: block;
                  transition: transform 300ms ease, color 300ms ease;
                  color: #26365a;
                  text-decoration: none;
                  transform-style: preserve-3d;
              }

              // .card.link-card:hover {
              //     transform: translate3d(0px, -6px, 0.01px);
              //     color: #26365a;
              // }

              .card.link-card.feature-item-colored {
                  display: -ms-grid;
                  display: grid;
                  overflow: visible;
                  min-height: 100%;
                  padding: 30px 40px;
                  flex-direction: column;
                  grid-auto-columns: 1fr;
                  grid-column-gap: 16px;
                  grid-row-gap: 0px;
                  -ms-grid-columns: 1fr;
                  grid-template-columns: 1fr;
                  -ms-grid-rows: auto auto;
                  grid-template-rows: auto auto;
                  border-style: none;
                  background-image: linear-gradient(180deg, #00c36e, #11845b);
                  transition: transform 300ms ease;
                  color: #f6fafb;
              }

              .benefit-block {
                  margin-top: 100px;
                  margin-bottom: 0px;
              }

            </style>
          </head>
          <body>
            ${clientsFinancingOffers.innerHTML}
          </body>
        </html>`;
      const htmlBlob = new Blob([htmlString], {type: 'text/html'});
      const file = new File([htmlBlob], 'myfile.html');
      let convertApi = ConvertApi.auth("token_pbmcXbr4");
      let params = convertApi.createParams();
      params.add('file', file);
      const pdfGen = await convertApi.convert('html', 'pdf', params);
      const urlOfFile = pdfGen.files[0].Url;
      const generatedPdf = (await getFile(urlOfFile)).data;
      this.download(generatedPdf);
      this.generatingPdf = false;
    },
    download(file) {
      const objectUrl = URL.createObjectURL(file);
      const pdfWindow = window.open(objectUrl, "_blank");
      pdfWindow.addEventListener("beforeunload", () => {
        if (pdfWindow.closed) {
          URL.revokeObjectURL(objectUrl);
        }
      });
    }
  },
  data: () => ({
    broker: null,
    purposeLabel: null,
    generatingPdf: false,
  }),
}
</script>

<style lang="scss" scoped>
.results-legend {
  display: -ms-grid;
  display: grid;
  min-width: 950px;
  margin-top: 20px;
  margin-bottom: 20px;
  padding-right: 20px;
  padding-left: 20px;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  justify-items: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  grid-auto-columns: 1fr;
  grid-column-gap: 16px;
  grid-row-gap: 16px;
  -ms-grid-columns: 0.5fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 0.5fr;
  grid-template-columns: 0.5fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 0.5fr;
  -ms-grid-rows: auto;
  grid-template-rows: auto;
}

.results-legend.zok {
  -ms-grid-columns: 0.5fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
  grid-template-columns: 0.5fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
  text-align: center;
}

.mortgage-parameters {
  display: -ms-grid;
  display: grid;
  min-width: 0px;
  margin-bottom: 0px;
  padding: 0px;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  justify-items: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  grid-auto-columns: 1fr;
  grid-column-gap: 16px;
  grid-row-gap: 16px;
  -ms-grid-columns: 0.5fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 0.5fr;
  grid-template-columns: 0.5fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 0.5fr;
  -ms-grid-rows: auto;
  grid-template-rows: auto;
  border-radius: 10px;
  background-color: transparent;
}

.mortgage-parameters.zok {
  -ms-grid-columns: 0.5fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
  grid-template-columns: 0.5fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
}

/* Generated on: Fri Mar 24 2023 18:02:23 GMT+0000 (Coordinated Universal Time) */
/* ==========================================================================
   normalize.css v3.0.3 | MIT License | github.com/necolas/normalize.css
   ========================================================================== */
/*! normalize.css v3.0.3 | MIT License | github.com/necolas/normalize.css */
html {
  font-family: sans-serif;
  -ms-text-size-adjust: 100%;
  -webkit-text-size-adjust: 100%
}

body {
  margin: 0
}

article,aside,details,figcaption,figure,footer,header,hgroup,main,menu,nav,section,summary {
  display: block
}

audio,canvas,progress,video {
  display: inline-block;
  vertical-align: baseline
}

audio:not([controls]) {
  display: none;
  height: 0
}

[hidden],template {
  display: none
}

a {
  background-color: transparent
}

a:active,a:hover {
  outline: 0
}

abbr[title] {
  border-bottom: 1px dotted
}

b,strong {
  font-weight: bold
}

dfn {
  font-style: italic
}

h1 {
  font-size: 2em;
  margin: .67em 0
}


html {
  height: 100%
}

body {
  margin: 0;
  min-height: 100%;
  background-color: #fff;
  font-family: Arial,sans-serif;
  font-size: 14px;
  line-height: 20px;
  color: #333
}

img {
  max-width: 100%;
  vertical-align: middle;
  display: inline-block
}

html.w-mod-touch * {
  background-attachment: scroll !important
}

.w-block {
  display: block
}

.w-inline-block {
  max-width: 100%;
  display: inline-block
}

h1,h2,h3,h4,h5,h6 {
  font-weight: bold;
  margin-bottom: 10px
}

h1 {
  font-size: 38px;
  line-height: 44px;
  margin-top: 20px
}

h2 {
  font-size: 32px;
  line-height: 36px;
  margin-top: 20px
}

h3 {
  font-size: 24px;
  line-height: 30px;
  margin-top: 20px
}

h4 {
  font-size: 18px;
  line-height: 24px;
  margin-top: 10px
}

h5 {
  font-size: 14px;
  line-height: 20px;
  margin-top: 10px
}

h6 {
  font-size: 12px;
  line-height: 18px;
  margin-top: 10px
}

p {
  margin-top: 0;
  margin-bottom: 10px
}



/* ==========================================================================
   Start of custom Webflow CSS
   ========================================================================== */
.w-layout-grid {
  display: -ms-grid;
  display: grid;
  grid-auto-columns: 1fr;
  -ms-grid-columns: 1fr 1fr;
  grid-template-columns: 1fr 1fr;
  -ms-grid-rows: auto auto;
  grid-template-rows: auto auto;
  grid-row-gap: 16px;
  grid-column-gap: 16px;
}

.header {
  display: flex;
  height: 400px;
  margin-right: -40px;
  margin-left: -40px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-image: url("https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f34_Header%20background-min.png");
  background-position: 50% 50%;
  background-size: cover;
  background-repeat: no-repeat;
}

.body {
  padding-right: 40px;
  padding-bottom: 40px;
  padding-left: 40px;
  background-color: #f8f9fa;
  font-family: Poppins, sans-serif;
  color: #0a1953;
  font-size: 18px;
  line-height: 23px;
  font-weight: 500;
}

.subeheading {
  max-width: 50%;
  margin-top: 20px;
  text-align: center;
}

.bold {
  font-weight: 700;
}

.bold.big {
  margin-bottom: 10px;
  font-size: 22px;
  line-height: 26px;
}

.list-of-offers {
  margin-top: -40px;
  margin-bottom: 100px;
}

.welcome-block {
  position: relative;
  display: flex;
  overflow: visible;
  max-height: 150px;
  margin-top: 60px;
  margin-bottom: 40px;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-end;
  border-radius: 10px;
  background-color: #edf5f7;
}

.welcome-block.oposit {
  margin-top: 100px;
  flex-direction: row-reverse;
}

.agentimage {
  width: 200px;
  height: 200px;
  border-bottom-left-radius: 10px;
  background-position: 50% 50%;
  background-size: cover;
  background-repeat: no-repeat;
}

.agentimage.oposit {
  border-bottom-left-radius: 0px;
  border-bottom-right-radius: 10px;
  background-position: 100% 50%;
  background-size: contain;
}

.message {
  position: absolute;
  left: 200px;
  top: -30px;
  width: 50%;
  padding: 20px;
  border-radius: 10px;
  background-color: #fff;
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.1);
}

.image {
  width: 200px;
  height: 200px;
  margin-right: -5px;
  margin-bottom: -20px;
  background-image: url("https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f30_invitation%20image.png");
  background-position: 50% 50%;
  background-size: contain;
  background-repeat: no-repeat;
}

.step-block {
  position: relative;
  display: -ms-grid;
  display: grid;
  margin-bottom: 40px;
  padding: 20px 40px 0px;
  justify-content: space-between;
  align-items: center;
  grid-auto-columns: 1fr;
  grid-column-gap: 16px;
  grid-row-gap: 16px;
  -ms-grid-columns: 1fr 1fr;
  grid-template-columns: 1fr 1fr;
  -ms-grid-rows: auto;
  grid-template-rows: auto;
  border-radius: 10px;
  background-color: #edf5f7;
}

.text-block {
  margin-right: 20px;
  margin-bottom: 60px;
}

.green {
  color: #258b66;
}

.step-number {
  position: absolute;
  left: 0%;
  top: auto;
  right: auto;
  bottom: 0%;
  display: flex;
  width: 100px;
  height: 100px;
  padding-top: 20px;
  padding-right: 20px;
  justify-content: center;
  align-items: center;
  border-bottom-left-radius: 10px;
  background-image: url("https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f33_step%20background.png");
  background-position: 50% 50%;
  background-size: contain;
  background-repeat: no-repeat;
  color: #fff;
  font-size: 42px;
  line-height: 42px;
  font-weight: 700;
}

.logo {
  width: 200px;
  height: 40px;
  background-image: url("https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f2e_logo%20ponuka%20financovania.svg");
  background-position: 50% 50%;
  background-size: contain;
  background-repeat: no-repeat;
}

.mockupimg {
  width: 100%;
  height: 400px;
}

.mockupimg._2step {
    background-image: url("https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f35_step%202%20image.png");
    background-position: 50% 100%;
    background-size: contain;
    background-repeat: no-repeat;
}

.mockupimg._3step {
    background-image: url("https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f2f_step%203%20image.png");
    background-position: 50% 100%;
    background-size: contain;
    background-repeat: no-repeat;
}

.mockupimg._4step {
    background-image: url("https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f31_step%204%20image.png");
    background-position: 50% 100%;
    background-size: contain;
    background-repeat: no-repeat;
}

.mockupimg.step-1 {
    background-image: url("https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f36_step%201%20image.png");
    background-position: 50% 100%;
    background-size: contain;
    background-repeat: no-repeat;
}

.card-feature-item-content {
  display: flex;
  flex-direction: column;
  flex: 1;
}

.heading-h3-size {
  color: #0a1953;
  font-size: 24px;
  line-height: 1.417em;
  font-weight: 700;
}

.heading-h3-size.color-neutral-100 {
  color: #fff;
}

.grid-3-columns {
  display: -ms-grid;
  display: grid;
  align-items: start;
  grid-auto-columns: 1fr;
  grid-column-gap: 28px;
  grid-row-gap: 28px;
  -ms-grid-columns: 1fr 1fr 1fr;
  grid-template-columns: 1fr 1fr 1fr;
  -ms-grid-rows: auto;
  grid-template-rows: auto;
}

.grid-3-columns.gap-32px {
  align-items: stretch;
  grid-column-gap: 32px;
  grid-row-gap: 32px;
}

.image-wrapper {
  display: flex;
  overflow: hidden;
  flex-direction: column;
  justify-content: center;
  transform: translate(0px, 0px);
}

.image-wrapper.alignright {
  align-items: flex-end;
}

.image-2 {
    width: 200px;
    height: 150px;
    background-image: url("https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912e7c_o%2040%25%20r%C3%BDchlej%C5%A1ie.png");
    background-position: 50% 50%;
    background-size: contain;
    background-repeat: no-repeat;
}

.image-2.uspesnost {
    background-image: url("https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912e7b_100%25%20%C3%BAspe%C5%A1nos%C5%A5.png");
}

.image-2.posudok {
    background-image: url("https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912e7a_s%20nami%20%C5%A1etr%C3%ADte.png");
}

.mg-bottom-32px {
  margin-bottom: 32px;
}

.mg-bottom-32px.greenbenefits {
  display: flex;
  margin-top: -60px;
  margin-bottom: 0px;
  justify-content: flex-end;
}

.card {
  overflow: hidden;
  border-style: solid;
  border-width: 1px;
  border-color: #eef5f7;
  border-radius: 24px;
  background-color: #fff;
  box-shadow: 0 2px 7px 0 rgba(20, 20, 43, 0.02);
}

.card.link-card {
  display: block;
  transition: transform 300ms ease, color 300ms ease;
  color: #26365a;
  text-decoration: none;
  transform-style: preserve-3d;
}

.card.link-card.feature-item-colored {
  display: -ms-grid;
  display: grid;
  overflow: visible;
  min-height: 100%;
  padding: 30px 40px;
  flex-direction: column;
  grid-auto-columns: 1fr;
  grid-column-gap: 16px;
  grid-row-gap: 0px;
  -ms-grid-columns: 1fr;
  grid-template-columns: 1fr;
  -ms-grid-rows: auto auto;
  grid-template-rows: auto auto;
  border-style: none;
  background-image: linear-gradient(180deg, #00c36e, #11845b);
  color: #f6fafb;
}

.benefit-block {
  margin-top: 100px;
  margin-bottom: 0px;
}

</style>